module.exports = __webpack_public_path__ + "img/is.1a166802.svg";